import { render, staticRenderFns } from "./FindIDPasswordPage.vue?vue&type=template&id=65481077"
import script from "./FindIDPasswordPage.vue?vue&type=script&lang=js"
export * from "./FindIDPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./FindIDPasswordPage.vue?vue&type=style&index=0&id=65481077&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports